module.exports = __webpack_public_path__ + "static/media/Erudio Indonesia.073908fc.png";